import { useState } from 'react'
import LassoModal from '../../../../components/LassoModal';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { LassoTab, LassoTabs } from '../../../../components/LassoTabs';
import { useSaveSharedQueryMutation } from '../../../../api/dataWranglerApiSlice';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import QueriesList from './QueriesList';
import ShareIcon from '@mui/icons-material/Share';
import { LassoFormField } from '../../../../components/form/LassoFormField';
import { useForm } from 'react-hook-form';
import { useUserInfoQuery } from '../../../../api/userApiSlice';
import useUserQueries from '../../hooks/useUserQueries';


interface FormValues {
    Email: string
}

const ShareQueryModal = ({ open, setOpen }: any) => {
    const {
        queries,
        queryTypes,
        selectedQuery,
        selectedQueryType,
        setSelectedQuery,
        handleTabChange,
        onSubmitLoadQuery,
        shouldDisableMyQueriesButton,
        shouldDisableLoadButton
    } = useUserQueries({ setOpen });
    const { data: userInfo } = useUserInfoQuery({});
    const [saveSharedQuery, { isLoading: isSharingQuery }] = useSaveSharedQueryMutation();
    const [step, setStep] = useState("select");
    const {
        control,
        handleSubmit,
        formState: { errors },
        setError,
        setValue,
        reset: resetForm
    } = useForm<FormValues>();

    const onSubmit = (newData: FormValues) => {
        const query = queries?.find((query) => query.id === selectedQuery);
        const body = {
            ...query,
            senderEmail: userInfo.email,
            receiverEmail: newData.Email
        }
        saveSharedQuery(body).then((response: any) => {
            if(response?.error) {
                const { data } = response.error
                setError('Email', { type: 'Not Found', message: data.short_message })
            }
            else {
                setStep("select")
                setOpen(false);
                setValue("Email", "")
            }
        })
    }

    const handleClose = () =>{
        setStep("select");
        setOpen(false);
        setValue("Email", "");
        resetForm()
    }

    const handleBackShareFormClick = () => {
        setStep('select')
        resetForm()
    }
    return (
        <LassoModal open={open} onClose={handleClose}>
            <Stack gap={3}>
                <Stack flexDirection="row" justifyContent="space-between">
                    <Typography fontSize="24px" fontWeight="600">Share Query</Typography>
                    <IconButton onClick={handleClose} >
                        <HighlightOffIcon />
                    </IconButton>
                </Stack>
                <Stack>
                    {step === "select" ?
                        <>
                            <LassoTabs value={selectedQueryType} onChange={handleTabChange}>
                                <LassoTab label="My Queries" value="own" />
                                <LassoTab label="Shared by me" value="sharedByMe" />
                                <LassoTab label="Shared with me" value="shared" />
                            </LassoTabs>
                            <Box width="550px" minHeight="550px">
                                <QueriesList
                                    queries={queryTypes[selectedQueryType] ?? []}
                                    selectedQuery={selectedQuery}
                                    setSelectedQuery={setSelectedQuery}
                                    selectable={selectedQueryType === 'own'}
                                />
                            </Box>
                            {selectedQueryType === 'own' ?
                                <Button
                                    variant="primary"
                                    onClick={() => setStep('submit')}
                                    sx={{ alignSelf: "center", mt: 3 }}
                                    disabled={shouldDisableMyQueriesButton()}
                                    startIcon={<ShareIcon />}
                                >
                                    Share Query
                                </Button>
                                : (selectedQueryType === 'sharedByMe' || selectedQueryType === 'shared') ?
                                    <Button variant="primary"
                                        sx={{ alignSelf: "center", mt: 3 }}
                                        onClick={onSubmitLoadQuery}
                                        disabled={shouldDisableLoadButton()}
                                    >
                                    Load Query
                                    </Button> : <></>
                            }
                        </>
                        :
                        <>
                            <Box width="550px" minHeight="350px">
                                <Button variant='tertiary' onClick={handleBackShareFormClick}>
                                    Back
                                </Button>
                                <QueriesList
                                    queries={queryTypes[selectedQueryType].filter((query: any) => query.id === selectedQuery) ?? []}
                                    selectedQuery={selectedQuery}
                                    setSelectedQuery={() => { }}
                                    selectable={false}
                                />
                            </Box>
                            <Stack alignItems="center">
                                <LassoFormField
                                    label = "Email" 
                                    controller={{
                                        name: "Email",
                                        control: control,
                                        rules: {
                                            required: "This field is required", pattern: {
                                                value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                                message: 'Invalid email address',
                                            },
                                        }

                                    }}
                                    required
                                    error={errors.Email}
                                    helperText={errors?.Email?.message || ""}
                                />
                                <Button
                                    variant="primary"
                                    onClick={handleSubmit(onSubmit)}
                                    sx={{ alignSelf: "center", mt: 3 }}
                                    startIcon={<ShareIcon />}
                                    disabled={isSharingQuery}
                                >
                                    Share Query
                                </Button>
                            </Stack>

                        </>
                    }
                </Stack>
            </Stack>

        </LassoModal>
    )
}

export default ShareQueryModal;